import {ProductType} from '../models/client-options.model';

export type ProductSlug = 'ai' | 'connect' | 'performance' | 'enrich' | 'webinars' | 'translations';

export const PRODUCT_ORDER: ProductType[] = [
    ProductType.ShineAI,
    ProductType.ShineConnect,
    ProductType.ShinePerformance,
    ProductType.ShineEnrich,
    ProductType.ShineTranslations,
    ProductType.ShineWebinars,
];

export const PRODUCT_SLUGS: Record<ProductType, ProductSlug> = {
    [ProductType.ShineAI]: 'ai',
    [ProductType.ShineTranslations]: 'translations',
    [ProductType.ShineConnect]: 'connect',
    [ProductType.ShinePerformance]: 'performance',
    [ProductType.ShineEnrich]: 'enrich',
    [ProductType.ShineWebinars]: 'webinars',
};

export function normalizeProductType(product: string): ProductType {
    const lower = product.toLowerCase();

    if (lower.includes('performance')) {
        return ProductType.ShinePerformance;
    }

    if (lower.includes('translation')) {
        return ProductType.ShineTranslations;
    }

    if (lower.includes('enrich')) {
        return ProductType.ShineEnrich;
    }

    if (lower.includes('connect')) {
        return ProductType.ShineConnect;
    }

    if (lower.includes('webinar')) {
        return ProductType.ShineWebinars;
    }

    return ProductType.ShineAI;
}

export function productSlugFromType(product: string): ProductSlug {
    return PRODUCT_SLUGS[normalizeProductType(product)];
}

export function productFromSlug(slug?: string | null): ProductType {
    console.log(slug);
    switch ((slug || '').toLowerCase()) {
        case 'translations':
            return ProductType.ShineTranslations;
        case 'enrich':
            return ProductType.ShineEnrich;
        case 'connect':
            return ProductType.ShineConnect;
        case 'performance':
            return ProductType.ShinePerformance;
        case 'webinars':
            return ProductType.ShineWebinars;
        default:
            return ProductType.ShineAI;
    }
}
